module.exports = __webpack_public_path__ + "img/home-02.d56cb607.png";